// Ченджлог админ-панели. ОБНОВЛЯТЬ КАЖДЫЙ ЗНАЧИМЫЙ ЦИКЛ (см. CLAUDE.md
// раздел «Правила работы»). Свежие записи сверху. Формат —
//   { version, title, publish, logs: { Новое|Изменено|Исправлено: [...] } }

export default [
  {
    version: '2.10',
    title: 'Навигация: убраны задвоения разделов',
    publish: '30 июня, 2026',
    logs: {
      Изменено: [
        'Меню упорядочено: «Карта сервисов» и «Потоки данных» объединены в одну группу «Карта сервисов» (Карта · Потоки данных); «Диаграммы» и «Схемы (drawio)» — в группу «Диаграммы» (Процессы · Схемы)',
        'В «Панели управления» вкладки задач сведены: «Задачи (GitLab)» — основной список из GitLab, «Локальный трекер» — оперативные/черновики. Дублирующая вкладка «Бэклог» убрана (это была та же таблица, что и «Задачи»)'
      ]
    }
  },
  {
    version: '2.09',
    title: 'Задачи: бэклог из GitLab',
    publish: '30 июня, 2026',
    logs: {
      Новое: [
        'В «Панель управления → Задачи» добавлена вкладка «GitLab» — единый бэклог задач из GitLab Work Items (проект common) с фильтром по меткам (labels), приоритетами, командами и ссылками на задачи',
        'Источник правды по задачам/бэклогу — GitLab Work Items; админка показывает их через защищённый прокси (без токенов в браузере)'
      ]
    }
  },
  {
    version: '2.08',
    title: 'Стабильность доступов и роли операторов',
    publish: '26 июня, 2026',
    logs: {
      Исправлено: [
        'Устранена причина «скачущего» меню и потери прав/выбранного проекта после простоя: при автообновлении сессии оператор больше не получает чужой набор ролей — сохраняются его реальная роль, проект и настройки',
        'Согласованы меню и доступ к данным: если пункт виден в меню, операция по нему больше не отдаёт «Доступ запрещён» (исправлен рассинхрон для операторов с прямым набором прав)',
        'Левое меню сразу подстраивается под обновлённую сессию без перезагрузки страницы'
      ],
      Изменено: [
        'В разделе «Операторы» кнопки действий заменены на компактные иконки: редактировать (карандаш), сброс пароля (щит), временный пароль (ключ), удалить (корзина)'
      ]
    }
  },
  {
    version: '2.07',
    title: 'Документация: скрытие паролей',
    publish: '26 июня, 2026',
    logs: {
      Новое: [
        'В документах пароли и реквизиты доступа теперь скрыты звёздочками (••••••). Видеть их в открытом виде могут только операторы с отдельным правом «Документация проекта: Просмотр секретов» (выдаётся в Ролях). Скрытие выполняется на сервере — без права значение не передаётся в браузер'
      ]
    }
  },
  {
    version: '2.06',
    title: 'Документация: полное оформление страниц',
    publish: '26 июня, 2026',
    logs: {
      Изменено: [
        'Страницы раздела «Документация» теперь открываются с полным оформлением (стили, иконки, изображения), а не «голым» текстом'
      ]
    }
  },
  {
    version: '2.05',
    title: 'Раздел «Документация» проекта',
    publish: '26 июня, 2026',
    logs: {
      Новое: [
        'Новый раздел «Документация» (в меню «Сервисы») — дерево документов выбранного проекта из корпоративной вики: бизнес-аналитика, система, сценарии, технические данные',
        'Поиск по документам и просмотр содержимого прямо в админке. Раздел доступен по отдельному праву «Документация проекта: Просмотр» (выдаётся в Ролях)'
      ]
    }
  },
  {
    version: '2.04',
    title: 'Истёкшая сессия: чистый выход на логин',
    publish: '26 июня, 2026',
    logs: {
      Исправлено: [
        'При полностью истёкшей сессии (когда и токен, и обновление недействительны — например после обновления сервера) вместо «шторма» ошибок 401 теперь один аккуратный переход на страницу входа: запрос обновления токена больше не зацикливается, повторные редиректы и зависание исключены'
      ]
    }
  },
  {
    version: '2.03',
    title: 'Панель управления: трекер задач (канбан)',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'В «Панели управления» появилась вкладка «Задачи» — канбан-доска по статусам с перетаскиванием карточек, номерами задач (#N), приоритетами и метками',
        'Карточка задачи: назначение исполнителя, метки, подзадачи и комментарии. Задачи привязаны к текущему проекту'
      ]
    }
  },
  {
    version: '2.02',
    title: 'Мониторинг: security-проверки сервисов',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'В разделе «Поддержка → Мониторинг → E2E» появилась группа «security» — пассивные проверки безопасности своих сервисов: наличие защитных HTTP-заголовков (HSTS, X-Frame-Options и др.), CORS не «*», срок TLS-сертификата, отсутствие утечки версий и открытых служебных роутов (/debug, /.env). Только чтение, без атак'
      ]
    }
  },
  {
    version: '2.01',
    title: 'Мониторинг: метрики контейнеров (CPU/RAM/Uptime)',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'На карточках «Доступность сервисов» (Поддержка → Мониторинг → Инфра) показываются CPU, RAM (использовано/лимит) и Uptime контейнера — когда на хосте поднят сборщик метрик (cAdvisor). Если он недоступен, карточки работают как раньше'
      ]
    }
  },
  {
    version: '2.00',
    title: 'Карта потоков данных: редактирование связей',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'На «Карте потоков данных» можно добавлять свои связи между сервисами (перетащить от узла к узлу, выбрав тип в панели) и удалять их (клик по своей связи, помеченной ✎). Связи сохраняются для текущего проекта и показываются поверх стандартной карты. Доступно при наличии права на изменение реестра сервисов'
      ]
    }
  },
  {
    version: '1.99',
    title: 'Диаграммы: карта потоков данных',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'В разделе «Диаграммы» появилась «Карта потоков данных» — видно, кто с кем взаимодействует и куда уходит информация: сервисы по зонам (Внешние → DMZ → Внутренние → Kafka → Партнёры), направленные связи с типом протокола (REST/gRPC/Kafka/…), подсветка точек входа, инспектор узла с входящими/исходящими потоками и поиск. Фильтруется по активным сервисам проекта'
      ]
    }
  },
  {
    version: '1.98',
    title: 'Карта сервисов: экспорт в PNG',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'На «Карте сервисов» появилась кнопка «PNG» — экспорт всей карты в картинку для документации/онбординга (с предупреждением, что изображение раскрывает внутренние адреса). Доступно при наличии права на просмотр реестра сервисов'
      ]
    }
  },
  {
    version: '1.97',
    title: 'Карта сервисов: сохранение раскладки на сервере',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'Раскладку «Карты сервисов» (позиции узлов + добавленные перетаскиванием сервисы) теперь можно сохранить на сервер для текущего проекта (кнопка «Сохранить») — она подгружается при открытии карты и видна с любого устройства, а не только в текущем браузере'
      ]
    }
  },
  {
    version: '1.96',
    title: 'Карта сервисов: добавление сервиса перетаскиванием',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'В левой панели «Карты сервисов» появилась «Палитра сервисов» — перетащите группу (Gateways, Finance, Compliance и т.д.) на холст, чтобы добавить новый сервис в нужной точке; он сразу открывается для редактирования. Палитра видна только при наличии права на добавление сервисов'
      ]
    }
  },
  {
    version: '1.95',
    title: 'Карта сервисов: отмена/повтор + E2E по сервисам',
    publish: '25 июня, 2026',
    logs: {
      Новое: [
        'На «Карте сервисов» появились отмена/повтор изменений топологии (кнопки ↶/↷ в панели, горячие клавиши Ctrl+Z / Ctrl+Shift+Z) — откатываются добавление/удаление/перемещение узлов; фильтры и поиск не затрагиваются',
        'В разделе «Поддержка → Мониторинг → E2E» synthetic-сценарии теперь сгруппированы по сервисам (admin-api / scoring / courses) со счётчиком ok/total на каждый сервис'
      ]
    }
  },
  {
    version: '1.94',
    title: 'Операторы: назначение роли вместо списка прав',
    publish: '25 июня, 2026',
    logs: {
      Изменено: [
        'В карточке оператора убран чек-лист отдельных прав — теперь оператору назначается роль (поле «Роль», обязательное). Права оператора определяются ролью; управление правами роли — в разделе «Справочники → Роли»',
        'В таблице операторов отображается роль оператора (одной колонкой)'
      ]
    }
  },
  {
    version: '1.93',
    title: 'Роли и операторы: исправления отображения',
    publish: '25 июня, 2026',
    logs: {
      Исправлено: [
        'В управлении ролями («Справочники → Роли») при редактировании роли не отображался список доступов — нельзя было добавить права (в т.ч. новые) в роль администратора. Список доступов теперь загружается всегда',
        'В списке операторов колонка теперь показывает роль оператора, а не перечень отдельных прав; убрана дублирующая колонка'
      ]
    }
  },
  {
    version: '1.92',
    title: 'Пароли операторов: сброс и временный пароль',
    publish: '24 июня, 2026',
    logs: {
      Новое: [
        'В разделе «Операторы» добавлены кнопки «Сброс пароля» (генерирует временный пароль и отправляет оператору на email) и «Врем. пароль» (задать вручную или сгенерировать) — оба требуют от оператора сменить пароль при первом входе',
        'При входе оператора с временным паролем показывается обязательный экран смены пароля — без смены работа в админ-панели заблокирована',
        'Добавлено отдельное право «Профиль оператора: Сброс/временный пароль» (раздел Роли) — выдаётся независимо от права на редактирование профиля'
      ]
    }
  },
  {
    version: '1.91',
    title: 'Пароли пользователей: сброс и временный пароль',
    publish: '24 июня, 2026',
    logs: {
      Новое: [
        'В карточке пользователя (Проверки → Профиль) добавлены кнопки «Сбросить пароль» (запускает восстановление — пользователю придёт код/ссылка) и «Временный пароль» (задать вручную или сгенерировать; пользователь обязан сменить его при первом входе)'
      ]
    }
  },
  {
    version: '1.90',
    title: 'Кросс-курсы: поиск и сортировка по столбцам',
    publish: '24 июня, 2026',
    logs: {
      Новое: [
        'В таблице «Крос курсы» добавлен поиск по паре и сортировка кликом по заголовкам столбцов (ID, Пара, Статус, Курс, Статус курса, Получен, лимиты) — со стрелкой направления; сортировка/фильтр применяются ко всему списку до пагинации'
      ]
    }
  },
  {
    version: '1.89',
    title: 'Курсы: курс/статус/время перенесены в таблицу кросс-курсов',
    publish: '24 июня, 2026',
    logs: {
      Изменено: [
        'В таблицу «Крос курсы» добавлены колонки «Курс», «Статус курса» (Актуален/Устарел) и «Получен» (время получения курса) — по каждой кросс-паре',
        'Убран отдельный пункт меню «Доступные валюты» — его данные теперь показываются прямо в таблице кросс-курсов'
      ]
    }
  },
  {
    version: '1.88',
    title: 'Мониторинг: карточки «Базы данных» + вкладка E2E',
    publish: '24 июня, 2026',
    logs: {
      Новое: [
        '«Инфра»: добавлены карточки «Базы данных» — размер БД, активные коннекты, commits/sec, cache hit ratio, deadlocks по каждому сервису (Postgres)',
        'Новая вкладка «E2E» — синтетические проверки ключевых подсистем на интервале: время последнего прогона, latency и доля успешных за 24 часа; при провале — отметка в логах (Telegram-алерт добавим следующей фазой)'
      ]
    }
  },
  {
    version: '1.87',
    title: 'Мониторинг: карточки доступности сервисов + chat/welID в каталоге',
    publish: '24 июня, 2026',
    logs: {
      Новое: [
        'Раздел «Поддержка → Мониторинг → Инфра»: добавлены карточки «Доступность сервисов» — HTTP-код, время ответа (latency) и срок действия TLS-сертификата по каждому сервису (включая support-chat и welID)',
        'Сервисы support-chat и welID добавлены в каталог сервисов — теперь видны в форме подключения проекта и на карте сервисов'
      ],
      Исправлено: [
        'Адрес KYC для admin-api исправлен (был неверный dev-адрес) — раздел KYC снова доступен после редеплоя'
      ]
    }
  },
  {
    version: '1.86',
    title: 'Доступы меню, стабильность сессии и выбор проекта',
    publish: '23 июня, 2026',
    logs: {
      Исправлено: [
        'Пункты меню (в т.ч. «Мониторинг») теперь корректно показываются по выданным правам — раньше пункт мог не появляться даже после назначения доступа',
        'Меню больше не «схлопывается» при простое и переходах: после автоматического обновления сессии набор доступов сохраняется',
        'Выбранный проект больше не сбрасывается — он запоминается на сервере и восстанавливается из токена (в т.ч. на другом устройстве)',
        'Список проектов в переключателе теперь подгружается надёжно сразу после входа (добавлен повтор запроса при гонке загрузки)'
      ]
    }
  },
  {
    version: '1.85',
    title: 'Курсы: читаемые кросс-пары + редактирование источников',
    publish: '23 июня, 2026',
    logs: {
      Новое: [
        'В таблице кросс-пар появилась кнопка «Изменить» — модалка позволяет менять надёжный источник, корректирующие и стабилизирующие котировки и лимиты без удаления и пересоздания пары'
      ],
      Изменено: [
        'Корректирующие и стабилизирующие котировки теперь показываются читаемо (символ пары · провайдер) вместо технических номеров; добавлена колонка «Надёжный источник»',
        'Таблица кросс-пар приведена к единому стилю админки'
      ]
    }
  },
  {
    version: '1.84',
    title: 'Мониторинг и Управление продуктом (бэклог)',
    publish: '23 июня, 2026',
    logs: {
      Новое: [
        'Раздел «Поддержка → Мониторинг» переработан во вкладки: «Инфра» (состояние gRPC-сервисов из /health/upstreams со светофором и счётчиком healthy/total), «Сводка» (ключевые показатели: операторы, активные сессии, действия за сутки, активные AML-кейсы, очередь KYC) и «Оповещения» (прежний CRUD-функционал сохранён)',
        'В «Панель управления» добавлены вкладки: «Обзор» (прежняя статистика), «Бэклог» (продуктовые задачи с приоритетом/статусом/комментариями, фильтр и lifecycle proposed→approved→in_progress→done/waiting/rejected) и «VPM» (снапшот здоровья продукта; LLM-рекомендации отключены до подписания Anthropic DPA)'
      ]
    }
  },
  {
    version: '1.83',
    title: 'Левое меню больше не пропадает (не требует перелогина)',
    publish: '23 июня, 2026',
    logs: {
      Исправлено: [
        'Левое меню переставало отображаться (оставались только Диаграммы/Поддержка/Ченджлог), и приходилось заново авторизоваться, чтобы оно вернулось. Причина — фильтр меню по правам «скрывал всё» при пустом наборе доступов (например после фонового обновления токена). Теперь при пустых доступах меню показывается полностью (доступ к данным всё равно защищён на бэкенде)'
      ]
    }
  },
  {
    version: '1.82',
    title: 'Курсы: исправлено добавление кросс-пары',
    publish: '22 июня, 2026',
    logs: {
      Исправлено: [
        'Форма добавления кросс-пары в разделе «Курсы» переработана. Раньше источник пары сохранялся с нулевым идентификатором, а корректирующие и стабилизирующие котировки вообще не добавлялись — кросс-пара создавалась нерабочей',
        'Теперь надёжный источник и котировки выбираются из реальных пар провайдеров (с указанием провайдера), корректирующие/стабилизирующие добавляются списком с возможностью удаления',
        'Базовую и котируемую валюту можно выбрать свободно — кросс-пару можно собрать, даже если прямой пары между ними нет'
      ],
      Изменено: [
        'Пары провайдеров загружаются один раз, добавлены индикаторы загрузки и понятное сообщение об ошибке; добавлен переключатель «только пары, связанные с base/quote»'
      ]
    }
  },
  {
    version: '1.81',
    title: 'Схемы (drawio): сохранение на сервере',
    publish: '11 июня, 2026',
    logs: {
      Изменено: [
        'Схемы в редакторе «Схемы (drawio)» теперь хранятся на сервере (per-project), а не локально в браузере — доступны на любом устройстве и пригодны для будущей wiki. Создание, открытие, автосохранение, переименование и удаление работают через бэкенд'
      ]
    }
  },
  {
    version: '1.80',
    title: 'Диаграммы: свободный редактор схем (drawio)',
    publish: '11 июня, 2026',
    logs: {
      Новое: [
        'В разделе «Диаграммы» добавлен пункт «Схемы (drawio)» — свободный редактор блок-схем и архитектурных диаграмм (встроенный drawio). Создание/переименование/удаление схем, полноэкранное редактирование, экспорт в SVG и PNG',
        'Редактор переиспользуемый — та же возможность будет доступна в будущей wiki для отрисовки всех схем платформы'
      ],
      Изменено: [
        'Структурированные диаграммы процессов (user-journey со зонами ответственности) остаются в прежнем разделе «Диаграммы»; drawio — отдельный свободный редактор'
      ]
    }
  },
  {
    version: '1.79',
    title: 'Инвентаризация сервисов платформы + документация новых сервисов',
    publish: '10 июня, 2026',
    logs: {
      Новое: [
        'Проведена полная инвентаризация 42+ сервисов платформы (выгружены и проанализированы все 39 репозиториев из реестра + 2 новых сервиса). Каждому присвоен статус: живой / заморожен / кандидат в архив',
        'Документация новых сервисов: Support-Chat (чат поддержки: виджет + операторский интерфейс + Telegram), WelID (KYC/AML-провайдер, бывший sumsub-mock), Exchanger Engines (контур обмена через внешних провайдеров — ранее не был описан вообще)',
        'Сводный аудит-документ со статусами всех сервисов, верифицированными находками и эскалациями руководству'
      ],
      Изменено: [
        'Описание сервиса Sender переписано с нуля (прежняя версия описывала несуществующие SendGrid/Twilio)',
        'Индекс документации актуализирован: статусы сервисов, 28 описаний, закрыт дрейф за 3 месяца',
        'В 9 устаревших описаний сервисов добавлены предупреждающие баннеры «документ расходится с кодом» — до планового переписывания',
        'База знаний AI-агентов дообучена: новые сервисы, граница AML-контуров, статус заморозки трейдинг-стека, известные ловушки конфигурации'
      ]
    }
  },
  {
    version: '1.78',
    title: 'Тексты уведомлений: чистка копирайта, push без задвоения, единый стиль',
    publish: '10 июня, 2026',
    logs: {
      Изменено: [
        'Push о депозите и выводе теперь приходит с отдельным заголовком и телом («Deposit received» / «1 LTC has been credited to your account»). Раньше сумма печаталась дважды и без заголовка — выглядело неаккуратно',
        'Все email-шаблоны (приветствие, депозит, вывод, блокировка, KYC, безопасность, сброс пароля, подтверждение email, транзакции, карты) переписаны UX-ревью под единый спокойный тон, без капслока и лишних восклицаний',
        'Из текстов убран зашитый бренд «Welcome to Trientes!» — шаблоны стали бренд-нейтральными (white-label): одна инсталляция корректно обслуживает несколько проектов',
        'Устранены дубли параметров в письмах: валюта в «Transaction alert» и номер транзакции в «Withdrawal» теперь упоминаются один раз'
      ],
      Новое: [
        'Скрипт размножения шаблонов по проектам получил режим синхронизации (SYNC_EXISTING): правки канонических текстов теперь могут пропагироваться во все проекты, а не теряться в их копиях. По умолчанию режим выключен — чтобы не затереть осознанную правку конкретного проекта'
      ]
    }
  },
  {
    version: '1.77',
    title: 'Mobile RegisterDevice gRPC — backend готов к интеграции',
    publish: '03 июня, 2026',
    logs: {
      Новое: [
        'api-gateway получил два новых gRPC-метода в gw.UserService — RegisterDevice и UnregisterDevice. Mobile-app вызывает их после SignIn (передаёт FCM-токен от Firebase SDK) и при Logout — и автоматически попадает в список устройств для push-нотификаций. user_id всегда извлекается из JWT, mobile не может зарегистрировать устройство на чужой аккаунт',
        'Создан handoff-документ docs/mobile/REGISTER_DEVICE.md для mobile-команды: контракт API, когда вызывать (после SignIn / в onTokenRefresh / при Logout), code-samples для Flutter (Dart), iOS (Swift), Android (Kotlin), security-notes, известные ограничения (iOS Simulator не получает FCM-токены)',
        'Идемпотентность: повторный RegisterDevice с тем же токеном — реактивирует запись (не дублирует), повторный UnregisterDevice на уже неактивный — возвращает false без ошибки. Mobile может вызывать «всегда» без боязни задублирования или ложных ошибок'
      ],
      Изменено: [
        'platform нормализуется к lowercase на стороне api-gateway: mobile может слать «iOS» / «Android» / «android», users-сервис всё равно получит строго ios/android/web (защита от мисматча CHECK constraint в БД)',
        'FCM-токен в логах api-gateway маскируется до первых 16 символов + ellipsis (тот же класс защиты что v60.8 redact-log fix в sender)'
      ]
    }
  },
  {
    version: '1.76',
    title: 'FCM push E2E через sender pipeline + ПЛАТФОРМЕННОЕ ПРАВИЛО service_connect',
    publish: '03 июня, 2026',
    logs: {
      Новое: [
        'Реализован полный E2E push до устройства пользователя через sender pipeline. Теперь оператор в «Отправка сообщений» выбирает канал Push + получателя по user_id → admin-api публикует в Kafka → sender worker резолвит FCM-токены через users.GetDeviceTokens → Firebase Admin SDK доставляет push. Раньше push в админке шёл только в notifications-сервис (in-app feed), FCM transport был dead code path',
        'Новый endpoint POST /sender/v1/send-push в admin-api — симметрично send-email/send-sms, target в Kafka остаётся пустым, sender-worker сам резолвит FCM-токены multicast по user_id',
        'Auto-select Отправителя в форме «Отправка сообщений» если для канала есть единственный вариант (Firebase FCM для push, UniOne для email, BlackBox для sms). Раньше оператор вынужден был кликать в dropdown с одним пунктом',
        'В CLAUDE.md в начало добавлено ПЛАТФОРМЕННОЕ ПРАВИЛО SERVICE_CONNECT (большими буквами) — admin_api_test.service_connect единственный источник правды для gRPC-адресов всех проектов. Env только override для разработки. При добавлении проекта обязательно создавать запись'
      ],
      Изменено: [
        'Sendmessage: при смене Вида отправки получатель НЕ сбрасывается. Раньше выбираешь Push → меняешь канал на Email → выбранный пользователь пропадал. Валидация формата (email vs phone) теперь только при клике Отправить',
        'admin-api `/sender/v1/send-push` принимает мнемоник шаблона ("welcome") и автоматически резолвит в UUID через sender ListTemplates (с fallback на `<title>_push`). Раньше требовался UUID, а Sendmessage.tsx передавал имя из хардкода TEXT_TEMPLATES',
        'Sender worker (case 2 push): если ParamEnricher универсально подставил target=user.email (как для email-канала) — игнорируем и идём в multicast. Раньше FCM пытался отправить на email и падал «not a valid FCM registration token»',
        'Sender FCM transport теперь логирует только public identifiers credentials (project_id, client_email, size) — без private_key. Раньше при INFO светил весь service-account JSON в логи контейнера'
      ],
      Исправлено: [
        'Восстановлены записи service_connect для проектов Bitbeon и Meinbit (отсутствовали — admin-api не мог работать с ними)',
        'Добавлены grpc_test/grpc_prod поля для svc-024 (sender) во все service_connect записи (раньше только HTTP, gRPC адрес sender admin-api не находил)',
        'Создан seed для notification_senders в sender_test_db (Firebase FCM / UniOne / BlackBox / Telegram Gateway) — раньше БД была пуста и dropdown «Отправитель» всегда показывал «нет вариантов»',
        'Исправлены 9 push-шаблонов в БД sender: params хранилось как пустой массив [] вместо объекта {}, GetTemplates падал с unmarshal error → весь flow редактирования шаблонов / резолва имени в UUID был блокирован',
        'cicd ansible-шаблон sender теперь пробрасывает FIREBASE_CREDENTIALS_PATH в контейнер (раньше GitLab CI var не доходил, FCM-канал disabled). env2yaml.py теперь YAML-quoting значений начинающихся с { / [ — иначе ansible получал dict вместо string'
      ]
    }
  },
  {
    version: '1.75',
    title: 'Push-нотификации на правильном языке + fail-open sidebar',
    publish: '01 июня, 2026',
    logs: {
      Исправлено: [
        'Welcome push (и все остальные push-нотификации из users/kyc/accounts/crypto-gateway) приходили на русском вместо текста из шаблона sender. Корень: TemplateResolver сравнивал по `t.Id` (UUID), но имя шаблона хранится в `t.Title` ("welcome_push"). Теперь match по Title (с fallback на Id для backward compat) — push-тексты резолвятся из БД sender как и задумано',
        'Sidebar админ-панели терял большинство пунктов меню если JWT claim `r` был пустой/corrupted — оператор оставался с только Диаграммы / Поддержка / Ченджлог. Логика переведена на fail-open: при отсутствии access-IDs все пункты показываются (бэкенд всё равно защищает данные через checkAccess). В DevTools будет console.warn если JWT corrupted'
      ],
      Новое: [
        'Чат-баг (зафиксирован в support-chat docs/13 §15): lock-проверка в operator UI сравнивает ws_session вместо operator_id — тот же оператор после F5/новой вкладки получает lock_denied на собственный диалог и input блокируется. Workaround: подождать 15 мин (stale lock release). Корневой fix — на chat-команде'
      ]
    }
  },
  {
    version: '1.74',
    title: 'Пакет 10 фиксов: верификация email, чат-lifecycle, курсы, матрица',
    publish: '01 июня, 2026',
    logs: {
      Исправлено: [
        'Письмо подтверждения email вело на app.trientes.com/verify-email (404 — у webapp нет роута). Дефолт ссылки переключён на api-gateway server-side landing (`/email/verify`)',
        'В разделе «Доступные валюты» (Курсы → Доступные валюты) актуальные курсы теперь загружаются автоматически при открытии страницы. Раньше открывалась пустой с подсказкой «Задайте фильтры и нажмите Применить»',
        'В «Кросс-парах» по умолчанию показаны только активные (toggle «Только активные» — ВКЛ). В header — счётчики «Активных: N / Всего: N». Раньше показывались все, активные терялись среди отключённых',
        'В колокольчике уведомлений убраны последние артефакты Falcon-template моков (defensive cleanup в data-файле — компонент был чистым с v65, но dead-data могли вернуться при случайном импорте)',
        'В support-chat шапке вместо названия проекта мог светиться UUID, если ProjectContext не успел подгрузиться. Теперь Spinner + «Загрузка проекта…»; UUID только в title-tooltip',
        'В матрице каналов добавлена post-save верификация: после сохранения админ-панель сравнивает отправленные правки с тем, что реально в БД, и при расхождении показывает конкретные ячейки + подсказку (проверить X-Project-ID). Раньше ложный «Сохранено: N» при невидимой проблеме'
      ],
      Новое: [
        'В support-chat: статус подключения теперь живой. «Подключение…» → «● Подключено» когда operator UI пришлёт сигнал готовности (postMessage). Через 15 сек без сигнала — warning с конкретными причинами (CHAT_JWT_SECRET, frame-ancestors, postMessage handler)',
        'Получен контракт postMessage для operator UI (chat-команде задокументирован в support-chat/docs/13 §14): `ready`, `active-dialogs`, `unread-count`, `token-expired`, `dialog-event`. После реализации chat-командой — admin-panel покажет счётчик активных диалогов в шапке + badge на навбар-кнопке Чат',
        'Email-шаблоны Trientes: в footer добавлен блок «Authorized activities include:» (4 пункта — обмен virtual↔fiat, virtual↔virtual, intermediation, maintenance) согласно макету. Copyright разделён на две строки. Требует re-seed на стороне sender (DEVOPS-задача)'
      ]
    }
  },
  {
    version: '1.73',
    title: 'Push-шаблоны через sender для KYC / Accounts / Crypto-Gateway',
    publish: '01 июня, 2026',
    logs: {
      Изменено: [
        'KYC push-нотификации (kyc_approved / kyc_rejected / kyc_doc_requested) больше не захардкожены в коде сервиса. Тексты резолвятся из sender (шаблоны редактируются оператором в админке «Шаблоны сообщений»). Если sender недоступен — fallback на захардкоженный русский, KYC-flow не блокируется',
        'Accounts push-нотификации (deposit / withdrawal / account_blocked) тоже переехали на sender resolver. Параметры %%amount%% / %%symbol%% / %%currency%% интерполируются в шаблоне',
        'Crypto-Gateway push «Транзакция подтверждена» (crypto_confirmed_push) переключён с устаревшего TemplateMsg-flow (notifications-svc БД) на единый sender-resolver. Теперь все push-тексты платформы — в одном источнике правды'
      ],
      Новое: [
        'Оператору необходимо создать 7 новых push-шаблонов в админке (kyc_approved_push, kyc_rejected_push, kyc_doc_requested_push, deposit_push, withdrawal_push, account_blocked_push, crypto_confirmed_push). До создания — fallback на дефолтный русский, ничего не ломается'
      ]
    }
  },
  {
    version: '1.72',
    title: 'Welcome-push через шаблоны + Logo показывает имя проекта',
    publish: '30 мая, 2026',
    logs: {
      Изменено: [
        'Welcome-push, account_blocked_push, account_unblocked_push при регистрации/блокировке пользователя больше не захардкожены в коде. Тексты резолвятся из sender (шаблоны редактируются оператором в админке «Шаблоны сообщений»). Если sender недоступен — fallback на захардкоженный русский, регистрация не блокируется',
        'Logo в navbar показывает имя текущего проекта вместо «Админ-панель» даже для операторов без права projectList (новый открытый endpoint /project/v1/my для базового справочника)'
      ]
    }
  },
  {
    version: '1.71',
    title: 'KYC strict level_name + runtime CSP detect + чат-диагностика',
    publish: '29 мая, 2026',
    logs: {
      Изменено: [
        'KYC: level_name обязателен в каждом запросе на access-token (раньше пустое поле молча fallback’илось на env SUMSUB_LEVEL, из-за чего на всех проектах в логах мока светился tesla-kyc / basic-kyc-level вместо настроенного per-project). Теперь 400 если не передан',
        'Вкладка «Поддержка → Чат»: убран hardcode хостов CSP, runtime-детекция через securitypolicyviolation event — warning показывается только при реальной блокировке iframe'
      ],
      Исправлено: [
        'Вкладка «Чат» в карточке проекта: конкретные сообщения вместо generic «Network Error» (раздельно показывает ошибки получения SSO-токена от admin-api и ошибки от chat-backend; подсказывает причину — CORS, expired session, отсутствие env CHAT_JWT_SECRET)'
      ]
    }
  },
  {
    version: '1.70',
    title: 'SUPPORT-CHAT-7 deactivate webhook',
    publish: '29 мая, 2026',
    logs: {
      Новое: [
        'При удалении или блокировке оператора админ-панель уведомляет chat-backend (POST /api/admin/operators/:external_id/deactivate). Раньше оператор мог оставаться залогиненным в operator UI до конца TTL chat-JWT (24 часа), даже после блокировки в админке'
      ]
    }
  },
  {
    version: '1.69',
    title: 'KYC-PROTO-2 + Фрод реальные данные',
    publish: '29 мая, 2026',
    logs: {
      Изменено: [
        'Вкладка Финмониторинг → Фрод подключена к реальным данным заблокированных пользователей (/user/v1/list?status=blocked). Раньше — захардкоженные моки. Кнопка «Снять блокировку» в модалке (если есть access userUnBlock)'
      ],
      Новое: [
        'KYC-PROTO-2: api-gateway пробрасывает level_name в kyc-svc (webapp/mobile может передать уровень верификации SumSub per-project)'
      ]
    }
  },
  {
    version: '1.68',
    title: 'Chat widget live + KYC per-project + admin endpoints',
    publish: '29 мая, 2026',
    logs: {
      Новое: [
        'Вкладка «Чат» в карточке проекта подключена к chat-backend admin endpoints (chat-команда реализовала §11 doc 13). Auto-load widget_shared_secret + индикатор «Установлен/Не установлен» с количеством активных сессий за 24ч',
        'Кнопка «Перевыпустить secret» с confirm-modal (destructive: старые embed-snippet ломаются)',
        'KYC-PROTO-2: api-gateway пробрасывает level_name в kyc-svc (webapp/mobile может передать уровень верификации SumSub per-project)'
      ],
      Изменено: [
        'Раздел Финмониторинг → Фрод подключён к реальным данным заблокированных пользователей (/user/v1/list?status=blocked). Раньше — захардкоженные моки. Кнопка «Снять блокировку» в модалке (если есть access userUnBlock)'
      ],
      Исправлено: [
        'KYC: убран хардкод default SUMSUB_LEVEL=tesla-kyc в Ansible шаблоне (для всех проектов в логах мока светился tesla-kyc level). Дефолт заменён на basic-kyc-level — project-agnostic. Per-project override — через GitLab CI var или новое поле kyc.proto::GetAccessTokenRequest.level_name'
      ]
    }
  },
  {
    version: '1.67',
    title: 'Бэклог: меню чистка + AML badge timestamp + dedup access',
    publish: '29 мая, 2026',
    logs: {
      Новое: [
        'AML/KYC bell-бейджи: при наведении показывают «Обновлено в HH:MM» (время последнего refresh счётчиков)'
      ],
      Изменено: [
        'Sidebar: убраны заглушки разделов «Биржа» и «Сабскан» (не имеют backend-эндпоинтов). Прямой URL остаётся доступен'
      ],
      Исправлено: [
        'Страница «Операторы»: React warning «two children with the same key» при дублях в /profile/v1/list_access (защита dedupById на фронте — работает для любого backend deploy)',
        'Sidebar: фильтр по правам пересчитывается при silent token refresh (раньше требовался reload страницы)'
      ]
    }
  },
  {
    version: '1.66',
    title: 'KYC mock_ss + NOTIF cleanup',
    publish: '29 мая, 2026',
    logs: {
      Новое: [
        'В карточке проекта вкладка «KYC» — настройка уровня верификации SumSub (levelName, ttl, auto-approve delay для CI)',
        'Документация подключения фронт-команды к KYC-моку (mock_ss/docs/INTEGRATION_FRONTEND.md)'
      ],
      Изменено: [
        'Backend admin-api: удалён мёртвый код NotifyService (после v60 шаблоны полностью на sender)',
        'Линт-фиксы в скриптах (defer gRPC.Close)'
      ]
    }
  },
  {
    version: '1.65',
    title: 'UI: имя оператора, чистка уведомлений, бренд',
    publish: '28 мая, 2026',
    logs: {
      Новое: [
        'В правом верхнем углу видно имя текущего оператора (раньше только инициалы NV)',
        'В карточке проекта вкладка «Чат» — конструктор snippet для встраивания виджета на сайт клиента'
      ],
      Изменено: [
        'Колокольчик уведомлений: убраны мок-данные старого Falcon-template, остались только реальные счётчики платформы (AML и т.д.)',
        'Кнопка «Чат» в верхней панели ведёт в раздел чата поддержки (раньше — на Логи)',
        'Auth-страницы (логин/логаут): убран хардкод «teslapay» — нейтральная подпись «Админ-панель»'
      ],
      Исправлено: [
        'При редактировании оператора группа сохраняется и подтягивается обратно при следующем открытии',
        'Logout-страница чистит сессию (token, refreshToken, currentProjectId) — раньше после прямого перехода на /logout данные оставались',
        'Восстановление пароля оператора шлёт корректный запрос с email (раньше — пустое тело → 400)',
        'Avatar не падает на русских именах (раньше «Оператор» → крах из-за \\w-regex)',
        'Сидбар: вкладка «Чат» снова видна всем авторизованным (access-гейт временно снят до раздачи прав через Роли)'
      ]
    }
  },
  {
    version: '1.62 — 1.63',
    title: 'Интеграция support-chat (SSO + widget)',
    publish: '28 мая, 2026',
    logs: {
      Новое: [
        'Раздел «Поддержка → Чат» — iframe operator UI support-chat сервиса',
        'Чат скоупится по активному проекту: при переключении проекта чат переключается',
        '/chat/v1/sso-token — выпуск JWT для SSO в operator UI (отдельный CHAT_JWT_SECRET от admin-api)',
        'Связка операторов admin-api ↔ chat-backend через external_id (UUID профиля)'
      ]
    }
  },
  {
    version: '1.59 — 1.61',
    title: 'Безопасность и навигация',
    publish: '28 мая, 2026',
    logs: {
      Новое: [
        'Sidebar фильтруется по правам оператора (JWT claim r): пункты без доступа скрыты',
        'NOTIF-001: push-уведомления по шаблонам резолвят шаблон из sender — единый источник правды'
      ],
      Изменено: [
        'Каталог access-ролей: добавлены пропущенные amlList и notifyConfig (раньше существовали в коде, но не возвращались UI)',
        'Список доступов на странице Роли сгруппирован по разделам (раньше плоский список с непонятным порядком)'
      ]
    }
  },
  {
    version: '1.55 — 1.58',
    title: 'KYC S3, email-конструктор, мультитенантность шаблонов',
    publish: '27 мая, 2026',
    logs: {
      Новое: [
        'KYC документы хранятся в Reg.ru Cloud S3 вместо локальной ФС',
        'Email-шаблоны: блочный конструктор (header/image/body/footer) с live-превью',
        'Текстовые шаблоны привязаны к проекту: каждый проект видит свои + глобальные fallback',
        'Создание оператора: пароль и логин отправляются ему на email (раньше письмо не содержало пароль)'
      ],
      Изменено: [
        'CRUD текстовых шаблонов переведён с notifications на sender (унификация хранения)',
        'Сборка admin-api на Go 1.25'
      ],
      Исправлено: [
        'Сброс чекбоксов прав при toggle «Активен» (отдельный state enabled)',
        'Утечка нового пароля в публичном /profile/v1/resetPassword — теперь только email',
        'Phone оператора обязателен — убран фейк-default «+71234567890» (дубли на unique constraint)'
      ]
    }
  },
  {
    version: '1.50 — 1.54',
    title: 'OTP via Telegram, scoring history, transactions',
    publish: '20 мая, 2026',
    logs: {
      Новое: [
        'Telegram Gateway OTP: для +7 номеров код приходит в @VerificationCodes, для остальных — SMS',
        'Раздел «История скоринга» — все scoring-операции (Marble + Crystal merge)',
        'Раздел «OTP-каналы» — управление маршрутизацией OTP по prefix телефона',
        'Раздел «Матрица каналов» — какие нотификации идут по email/sms/push для каждого события'
      ],
      Изменено: [
        'AML кейсы: пользователь и email загружаются через batch резолв (раньше N+1 запросов)',
        'Транзакции: Отправитель/Получатель отображаются именем оператора (резолв accounts → users gRPC)'
      ]
    }
  },
  {
    version: '1.40 — 1.49',
    title: 'AML, Kafka-интеграция, Email через UniOne',
    publish: '15 апреля, 2026',
    logs: {
      Новое: [
        'Раздел AML: вкладка Финмониторинг с очередью кейсов, фильтрами, скор-карточкой, таймлайном',
        'Kafka producers в Users/KYC/Accounts/Crypto-GW: push + email + sms через sender',
        'Sidebar badge: счётчики активных AML-кейсов и KYC applicant PENDING',
        'Подтверждение email через ссылку (verify-email flow)',
        'Двухфакторная аутентификация (TOTP RFC 6238) для операторов'
      ],
      Изменено: [
        'Email-шаблоны переведены на HTML с дизайном Trientes (Figma)',
        'Поддержка нескольких проектов в админке (X-Project-ID header, мультитенантность)'
      ],
      Исправлено: [
        'Pagination в /user/v1/list (параметр size вместо limit)',
        'KYC gRPC integration: HMAC webhook, eth_ префикс, PII в логах',
        'Courses: 12 багов в расчёте кросс-курсов (перепутанные переменные, потеря точности float64)'
      ]
    }
  },
  {
    version: '1.20 — 1.39',
    title: 'Раздел диаграмм, AI-агенты, документация',
    publish: '15 марта, 2026',
    logs: {
      Новое: [
        'Раздел «Диаграммы процессов» — swimlane-диаграммы на React Flow с drag & drop',
        'Раздел «Карта сервисов» (Service Map) — интерактивная карта микросервисов',
        '15 бизнес-сценариев в формате swimlane (SC-001..SC-015, включая AML)',
        'Раздел «Финмониторинг» с поддержкой 15 AML-правил (115-ФЗ, FATF, OFAC и т.д.)'
      ],
      Изменено: [
        'Дизайн-унификация всех таблиц по AML-стилю (hover, size sm, table-light header, бейджи)',
        'Раздел «Поддержка» переведён на /support, /chat, /support-monitoring (отдельные страницы)'
      ]
    }
  },
  {
    version: '1.10 — 1.19',
    title: 'Документация и архитектура',
    publish: '3 марта, 2026',
    logs: {
      Новое: [
        'Полная документация 25 микросервисов и 2 шлюзов',
        'Архитектурное описание платформы (ARCHITECTURE.md)',
        'Аудит безопасности всех сервисов (баг-репорты)',
        'Верификация схем БД (8 баз данных)'
      ]
    }
  },
  {
    version: '1.0.2',
    title: 'Транзакции / Поиск операций',
    publish: '21 мая, 2024',
    logs: {
      Новое: ['Страница поиска операций', 'Форматирование кода']
    }
  },
  {
    version: '1.0.1',
    title: 'Главное окно',
    publish: '20 мая, 2024',
    logs: {
      Новое: [
        'Создание проекта',
        'Выкладка в Git',
        'Подготовка главного окна, чистка',
        'Главное меню',
        'Страница ченджлога для фиксации разработок'
      ]
    }
  },
  {
    version: '1.0.0',
    title: 'Инициализация проекта',
    publish: '10 мая, 2024'
  }
];
